// OurValuesData.js
export const ourValuesData = {
    title: "Our Values",
    description:
      "We have anchored ourselves to six key principles which underpin how we operate and the way we act moving forward.",
    values: [
      {
        title: "SAFETY",
        description:
          "Uphold our exceptional health and safety standards and focus on everyone’s well-being.",
      },
      {
        title: "RESPECT",
        description:
          "Respect colleagues, clients, the environment and the cultures and communities where we operate.",
      },
      {
        title: "UNITY",
        description: "Operate as a fully inclusive global team.",
      },
      {
        title: "INTEGRITY",
        description:
          "Be frank, honest, and open, developing relationships and seeing things through to completion.",
      },
      {
        title: "SUSTAINABILITY",
        description:
          "Identify, develop and implement initiatives to lessen our environmental impact.",
      },
      {
        title: "EXCELLENCE",
        description:
          "Be responsive, innovative and entrepreneurial, taking ownership and always striving for the best outcomes.",
      },
    ],
  };